// extracted by mini-css-extract-plugin
export default {"form_container":"ContentForm_form_container__JH-Bo","title_chars":"ContentForm_title_chars__a8DzY","gradient-animation":"ContentForm_gradient-animation__4QFvw"};